import NewsDetailLayout from '../NewsDetailLayout';
import { choryokuData } from '../newsDetailData';

const ChoryokuDetail = () => <NewsDetailLayout data={choryokuData} />;
export default ChoryokuDetail;
